import { useQuery } from '@tanstack/react-query'

import { DEFAULT_IMAGE_SRC } from '@/lib/Images/imageFallbacks.ts'
import { systemSettingsQueryOptions } from '@/lib/Queries/appQueries.ts'

export default function useLoginHeaderLogic() {
    const { data: systemSettings } = useQuery(systemSettingsQueryOptions())
    const logoSrc = systemSettings?.logoSrc ?? DEFAULT_IMAGE_SRC

    return {
        state: {
            companyName: systemSettings?.companyName ?? 'Joomla Updater API',
            logoSrc,
            hasCustomLogo: Boolean(
                systemSettings?.logoSrc &&
                systemSettings.logoSrc !== DEFAULT_IMAGE_SRC,
            ),
        },
    }
}
